import { AuthenticationService } from '@alfresco/adf-core';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigurarPastaServiceService } from 'app/configurar-pasta-service.service';
import { PastaArquivistica } from 'app/model/pasta/pasta.model';
import { Observable } from 'rxjs';
import { PermissoesService } from 'app/service/usuario/permissoes.service';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';

@Component({
  selector: 'app-configurar-pasta',
  templateUrl: './configurar-pasta.component.html',
  styleUrls: ['./configurar-pasta.component.scss'],
})
export class ConfigurarPastaComponent implements OnInit {
  pastaArquivistica: PastaArquivistica;
  clienteId: number;
  pastasArquivi: PastaArquivistica[];
  orderForm: FormGroup;
  loading = false;
  private arrayString: string;
  public folderEditor = false;
  public superUser = false;
  node: string;
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';

  constructor(
    private route: ActivatedRoute,
    private _snackBar: MatSnackBar,
    private service: ConfigurarPastaServiceService,
    private formBuilder: FormBuilder,
    private authService: AuthenticationService,
    private router: Router,
    private permissoesService: PermissoesService
  ) {
    this.route.params.subscribe((params) => {
      this.clienteId = params['id'];
      this.getPermissionCliente(this.clienteId);
    });
    this.listarPastas();
  }

  ngOnInit() {
    this.orderForm = this.formBuilder.group({
      nodeId: null,
      idCliente: this.clienteId,
      ativo: true,
    });
  }

  getPermissionCliente(idCliente: number) {
    this.loading = true;
    this.permissoesService.getPermissionEmpresa(idCliente).subscribe(data => {
    const arrayAuthorityCliente: any[] = [];
    data.forEach(el => {
      arrayAuthorityCliente.push(el.authority);
    });
    this.permissoesService.setItemAuthority('authority-Empresa', arrayAuthorityCliente);
    this.getAuthority();
    this.loading = false;
  }, err => {
    this.loading = false;
    console.error(err);
    this.openSnackBarError('Ocorreu um erro, tente novamente mais tarde');
  });
}

getAuthority() {
  this.arrayString = this.permissoesService.getItemAuthority('authority-Empresa');
  if (this.arrayString.includes('EDIT_FOLDER')) {
    this.folderEditor = true;
  }
  if (this.arrayString.includes('SUPER_USER')) {
    this.superUser = true;
  }
}

  listarPastas() {
    this.service.getPastasByIdCliente(this.clienteId).subscribe((data) => {
      this.pastasArquivi = data;
    });
  }

  adicionarPasta() {
    if (this.node != '') {
      this.orderForm.get('nodeId').setValue(this.node);
      console.log(this.orderForm.value);

      this.service.salvarPastaArquivistica(this.orderForm.value).subscribe(
        (data) => {
          this.pastasArquivi.push(data);
        },
        (err) => {
          this.openSnackBarError('Pasta não encontrada no repositório!');
        }
      );

      this.pastasArquivi.forEach((element) => {});
      this.node = '';
    }
  }

  alterarStatus(obj) {
    if (confirm('Tem certeza que deseja alterar o status?')) {
      this.service.updatePastaArquivistica(obj).subscribe(
        (data) => {
          let index = this.pastasArquivi.indexOf(obj);
          this.pastasArquivi[index] = data;
        },
        (err) => {
          this.openSnackBarError('Pasta não encontrada no repositório!');
        }
      );

      this.pastasArquivi.forEach((element) => {});
    } else {
    }
  }

  // SnackBares
  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ['success-snackbar'],
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ['error-snackbar'],
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/configurar-pasta/configurar-pasta.component.ts